import React from 'react';
import { Check } from 'lucide-react';
const criteria = ['Jesteś nauczycielem WF lub trenerem siatkówki w szkole, klubie lub akademii', 'Masz dość ciężkiej pracy bez jasnego systemu', 'Chcesz przestać wymyślać nowe plany co tydzień samodzielnie', 'Chcesz żeby zajęcia szły dobrze nawet w dni gdy nie jesteś przygotowany w 100%', 'Chcesz żeby rodzice widzieli konkretne wyniki pracy z ich dziećmi', 'Chcesz rozwijać każdego ucznia systematycznie i mierzalnie'];
export function WhoFor() {
  return <section className="w-full bg-cream-alt py-12 md:py-20 px-4 md:px-6" data-id="element-345">
      <div className="max-w-6xl mx-auto" data-id="element-346">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-center text-white mb-8 md:mb-12" data-id="element-347">
          Ten system jest dla Ciebie, jeśli...
        </h2>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-348">
          {criteria.map((item, index) => <div key={index} className="bg-[#1A3257] border border-[#1E3A5F] rounded-2xl p-5 md:p-6 shadow-lg flex gap-3 md:gap-4 h-full" data-id="element-349">
              <div className="flex-shrink-0" data-id="element-350">
                <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-gold-accent flex items-center justify-center" data-id="element-351">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-[#0A1628]" data-id="element-352" />
                </div>
              </div>
              <p className="text-sm md:text-base text-[#E8EAF0] leading-relaxed" data-id="element-353">
                {item}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}